import ReportDeatil from './report_detail'
import requireAuth from '../../require-auth'

export default requireAuth(ReportDeatil)



// WEBPACK FOOTER //
// ./src/components/pages/report_detail/index.ts